(() => {
  const enhanceArticle = (root) => {
    if (!root || root.dataset.snugseeEnhanced === 'true') return;

    const content = root.querySelector('[data-snugsee-content]');
    if (!content) return;

    root.dataset.snugseeEnhanced = 'true';

    content.querySelectorAll('img:not([src])').forEach((image) => image.remove());

    const children = Array.from(content.children);
    const firstHeadingIndex = children.findIndex((child) => child.matches('h2'));

    if (firstHeadingIndex > 0) {
      const intro = document.createElement('div');
      intro.className = 'snugsee-article__intro';
      content.insertBefore(intro, children[0]);
      children.slice(0, firstHeadingIndex).forEach((child) => intro.appendChild(child));
    }

    let currentSection = null;
    Array.from(content.children).forEach((child) => {
      if (child.matches('h2')) {
        currentSection = document.createElement('section');
        currentSection.className = 'snugsee-content-section';
        content.insertBefore(currentSection, child);
      }

      if (currentSection && child !== currentSection) {
        currentSection.appendChild(child);
      }
    });

    content.querySelectorAll('.snugsee-content-section').forEach((section, index) => {
      section.dataset.sectionIndex = String(index + 1).padStart(2, '0');

      const mediaParagraph = Array.from(section.children).find(
        (child) => child.querySelector && child.querySelector('img[src]')
      );
      if (mediaParagraph) {
        mediaParagraph.classList.add('snugsee-content-section__media');
        section.classList.add('snugsee-content-section--has-media');
      }

      if (section.querySelector('ul')) {
        section.classList.add('snugsee-content-section--has-list');
      }
    });
  };

  const init = () => {
    document.querySelectorAll('[data-snugsee-article]').forEach(enhanceArticle);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches && event.target.matches('[data-snugsee-article]')) {
      enhanceArticle(event.target);
      return;
    }

    event.target.querySelectorAll('[data-snugsee-article]').forEach(enhanceArticle);
  });
})();
